import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Cookie } from 'lucide-react';

export const Cookies: React.FC = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <Helmet>
        <title>Cookie Policy - Asphalt Calculator</title>
        <meta name="description" content="Cookie policy for the Asphalt Calculator website. Learn about how we use cookies." />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl p-8">
        <div className="flex items-center mb-8">
          <Cookie className="h-8 w-8 text-blue-600 mr-3" />
          <h1 className="text-3xl font-bold text-slate-800">Cookie Policy</h1>
        </div>

        <div className="prose max-w-none">
          <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">What Are Cookies</h2>
            <p className="text-slate-600 mb-4">
              Cookies are small text files that are placed on your computer or mobile device when you visit our website.
              They are widely used to make websites work more efficiently and provide information to the website owners.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">How We Use Cookies</h2>
            <p className="text-slate-600 mb-4">We use cookies to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Remember your calculation preferences</li>
              <li>Understand how you use our website</li>
              <li>Improve our services</li>
              <li>Provide analytics data</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Types of Cookies We Use</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-slate-800 mb-2">Essential Cookies</h3>
                <p className="text-slate-600">Required for the website to function properly.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-slate-800 mb-2">Analytics Cookies</h3>
                <p className="text-slate-600">Help us understand how visitors interact with our website.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-slate-800 mb-2">Advertising Cookies</h3>
                <p className="text-slate-600">Used to deliver relevant advertisements and track ad performance.</p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Managing Cookies</h2>
            <p className="text-slate-600 mb-4">
              Most web browsers allow you to control cookies through their settings preferences.
              However, limiting cookies may affect the functionality of our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contact Us</h2>
            <p className="text-slate-600">
              If you have any questions about our Cookie Policy, please contact us at:
              <br />
              Email: info@asphaltcalculator.online
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};